export default __webpack_public_path__ + "static/media/2.4cec0f07.svg";